export const PRODUCT_LINES = {
  NLT_ARVAL: 'NLT_ARVAL',
  NLT_BRUMBRUM: 'NLT_BRUMBRUM',
  NONE: 'NONE',
  STANDARD: 'STANDARD',
  USATO_GARANTITO_ARVAL: 'USATO_GARANTITO_ARVAL',
}
